import { useState, useEffect } from 'react';

const CACHE_KEY = 'sharjah_weather_v1';
const CACHE_TTL = 10 * 60 * 1000; // 10 minutes

export function useWeather() {
  const [data,    setData]    = useState(null);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);

  useEffect(() => {
    // Return sessionStorage cache if fresh
    try {
      const cached = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      if (cached && Date.now() - cached.ts < CACHE_TTL) {
        setData(cached.data);
        setLoading(false);
        return;
      }
    } catch {}

    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 8000);

    const isDev = process.env.NODE_ENV === 'development';
    const url = isDev
      ? 'https://wttr.in/sharjah?format=j1'
      : '/api/weather.php';

    fetch(url, { signal: controller.signal })
      .then(r => { if (!r.ok) throw new Error(`HTTP ${r.status}`); return r.json(); })
      .then(json => {
        clearTimeout(timer);
        // wttr.in returns raw JSON; PHP proxy wraps it with status:'ok'
        const cur   = isDev ? json.current_condition[0] : null;
        const today = isDev ? json.weather[0]           : null;
        const d = isDev ? {
          tempC:       parseInt(cur.temp_C),
          feelsLikeC:  parseInt(cur.FeelsLikeC),
          humidity:    cur.humidity,
          windKmph:    cur.windspeedKmph,
          description: cur.weatherDesc[0].value,
          minC:        parseInt(today.mintempC),
          maxC:        parseInt(today.maxtempC),
        } : {
          tempC:       json.tempC,
          feelsLikeC:  json.feelsLikeC,
          humidity:    json.humidity,
          windKmph:    json.windKmph,
          description: json.description,
          minC:        json.minC,
          maxC:        json.maxC,
        };
        try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ data: d, ts: Date.now() })); } catch {}
        setData(d);
        setLoading(false);
      })
      .catch(err => {
        clearTimeout(timer);
        setError(err);
        setLoading(false);
      });

    return () => { clearTimeout(timer); controller.abort(); };
  }, []);

  return { data, loading, error };
}
